/*jshint esversion: 6 */
class MapGL {

  constructor(container, zoom, minZoom, center, style, controls) {
    this.container = container;
    this.zoom = zoom;
    this.minZoom = minZoom;
    this.center = center;
    this.style = style;
    this.controls = controls;

    if (this.controls == null) {
      this.controls = {
        navigation: {enable: 1, position: 'bottom-right', showCompass: true},
        geolocate: {enable: 1, position: 'bottom-right'},
        fullscreen: {enable: 1, position: 'bottom-right'},
      };
    }

    this.layers = [];
    this.map = null;
    this.popup = null;
    this.tooltip = null;

    this.init();
  }

  init() {

    var maxBounds = [
      [4.53, 45.54], // Southwest coordinates
      [5.16, 45.99]  // Northeast coordinates
    ];

    this.map = new maplibregl.Map({
      container: this.container,
      style: this.style,
      center: this.center,
      zoom: this.zoom,
      minZoom: this.minZoom,
      attributionControl: false,
      maxBounds: maxBounds,
      locale: {
        'NavigationControl.ZoomIn': 'Zoomer',
        'NavigationControl.ZoomOut': 'Dézoomer',
        'NavigationControl.ResetBearing': 'Modifier l\'orientation',
        'GeolocateControl.FindMyLocation': 'Afficher votre position',
        'FullscreenControl.Enter': 'Afficher en plein écran',
        'FullscreenControl.Exit': 'Quitter le plein écran'
      }
    });

    this.popup = new maplibregl.Popup();
    this.tooltip = new maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      className: 'popup-tooltip'
    });

    var attributionControl = new maplibregl.AttributionControl({
      compact: true,
      customAttribution:
        '&copy; <a href="https://openmaptiles.org/" target="_blank" title="Accéder au site OpenMapTiles (nouvelle fenêtre)">OpenMapTiles</a>&nbsp;' +
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" title="Accéder au site OpenStreetMap (nouvelle fenêtre)">les contributeurs OpenStreetMap</a>&nbsp;' +
        '&copy; <a href="https://data.grandlyon.com/cgu" target="_blank" title="Accéder au site Data Grand Lyon (nouvelle fenêtre)">Data Grand Lyon</a>'
    });

    this.map.addControl(attributionControl, 'bottom-right');

    if (this.controls.navigation && this.controls.navigation.enable === 1) {
      var navigationControl = new maplibregl.NavigationControl({
        showCompass: this.controls.navigation.showCompass
      });
      this.map.addControl(navigationControl, this.controls.navigation.position);
    }

    if (this.controls.geolocate && this.controls.geolocate.enable === 1) {
      var geolocateControl = new maplibregl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: false
      });
      this.map.addControl(geolocateControl, this.controls.geolocate.position);
    }

    if (this.controls.fullscreen && this.controls.fullscreen.enable === 1) {
      var fullscreenControl = new maplibregl.FullscreenControl();
      this.map.addControl(fullscreenControl, this.controls.fullscreen.position);
    }
  }

  getMapObject() {
    return this.map;
  }

  getPopup() {
    return this.popup;
  }

  getTooltip() {
    return this.tooltip;
  }
}
